import React from "react";
import HomeTabs from "./HomeTabs";
import { Breadcrumb } from "antd";
import { useState } from "react";


const Home: React.FC = () => {
  const [breadcrumb,setBreadcrumb] = useState("Breadcrumb")
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">Home</h1>
        <div className="mb-4">
          <Breadcrumb separator=">" items={[{ title: "Home" }, { title: breadcrumb}]} className="text-xs sm:text-base"/>
        </div>
        <HomeTabs setBreadcrumb={setBreadcrumb} />
      </div>
    </div>
  );
};

export default Home;
